define((require) => {
    "use strict";

    const CustomJsAction     = require("shared/ui/experience/action/customJs/CustomJsAction");
    const ProductActionMixin = require("shared/ui/experience/action/product/ProductActionMixin");

    /**
     * Open a product via JavaScript code.
     *
     * @class ProductCustomJsAction
     * @constructor
     */
    return CustomJsAction.extend("ProductCustomJsAction", {

        mixin: ProductActionMixin,

        // Product related logic lives on the client page, not in the Viewer; this type of action thus requires
        // access to client space to make sense...
        _clientSpace: true

    }, {
        TYPE: "productCustomJs"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/product/ProductCustomJsAction.js